import { render, staticRenderFns } from "./TwProcessDetailStandard.vue?vue&type=template&id=7ebb6978&scoped=true&"
import script from "./TwProcessDetailStandard.vue?vue&type=script&lang=js&"
export * from "./TwProcessDetailStandard.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessDetailStandard.vue?vue&type=style&index=0&id=7ebb6978&lang=scss&scoped=true&"
import style1 from "./TwProcessDetailStandard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebb6978",
  null
  
)

export default component.exports